module.exports = __webpack_public_path__ + "static/media/googleColor.e47ad5cd.svg";